export default {
	unlinkArtistProfile: (artistId: number) => `/profiles/${artistId}`,
};
